import { gql } from '@apollo/client';
import UPDATE_CLASSROOM_SETTING_FRAGMENT from '../../fragments/update-classroom-setting-fragment';

const UPDATE_KEY_CLASSROOM_SKIP_JUMP_IN_SETTING = gql`
  mutation updateKeyClassroomSettingSkipJumpIn(
    $data: [UpdateKeyClassroomSettingSkipJumpInInput!]!
  ) {
    updateKeyClassroomSettingSkipJumpIn(data: $data) {
      ...UpdateClassroomSettingFragment
    }
  }
  ${UPDATE_CLASSROOM_SETTING_FRAGMENT}
`;

export default UPDATE_KEY_CLASSROOM_SKIP_JUMP_IN_SETTING;
